import {FC} from 'react'
import {Container} from 'react-bootstrap'
import Breadcrumb from './Breadcrumb'
import {useBreadcrumb} from '../../hooks/useBreadcrumb'
import {useUser} from '../../contexts/UserContext'

interface BreadcrumbBarProps {
  fullWidth?: boolean
}

const BreadcrumbBar: FC<BreadcrumbBarProps> = ({fullWidth = false}) => {
  const {breadcrumbs} = useBreadcrumb()
  const {user} = useUser()

  const isPlayer = user?.roles?.[0] === 'PLAYER'

  if (isPlayer || !breadcrumbs || breadcrumbs.length === 0) {
    return null
  }

  return (
    <div className="breadcrumb-bar">
      <Container fluid={fullWidth ? true : 'xl'} className="px-3 px-lg-4 d-flex align-items-center">
        <Breadcrumb/>
      </Container>
    </div>
  )
}

export default BreadcrumbBar
